export default "__VITE_ASSET__edb71da3__"